import { PageSizeOptionEnum } from '../../../enums';
import { TTableColumnOrderDirection } from '../../useTable';

const TablePreserverCommonInitialTableValues = {
  activePage: 1,
  perPage: PageSizeOptionEnum.Twenty,
  searchQuery: undefined,
  columnOrderBy: undefined,
  columnOrderDirection: '' as TTableColumnOrderDirection,
  securityScoreName: undefined,
  dateRange: undefined,
};

export default TablePreserverCommonInitialTableValues;
